import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['La cabeza pesada desde que te levantás y para el mediodía ya no podés más.', 'Leés la misma línea tres veces y no entra.', 'Tu médico dijo "es estrés" o "es la menopausia" y nada funcionó.', 'Hinchazón, gases y fatiga mental que nadie te conectó.', 'Cada solución fue temporal. El problema siempre volvió.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-157">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-158" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-159">
        <div className="max-w-4xl mx-auto" data-id="element-160">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-161">
            <h2 className="md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif] text-[24px]" data-id="element-162">
              ¿Cuántos años más vas a vivir pensando que "es la edad"?
            </h2>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-163">
              Buscás respuestas. Cuidás lo que comés. Hacés todo bien.
            </p>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-164">
              Pero nadie te explicó lo que realmente está pasando adentro.
            </p>
            <p className="text-xl text-brand-light font-medium" data-id="element-165">
              No es la edad. No es falta de voluntad. Es falta de un sistema.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-166">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-167">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-168" />
                <p className="text-lg text-gray-200" data-id="element-169">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-170">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-171">
              ¿Y si este fuera el último día que vivís así?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}